import "normalize.css/normalize.css";
import debounce from "lodash/fp/debounce";

import { embedAllTrack } from "../../utils/script";

import "./style.scss";
import { changeQueryString, getParamUrl, historyPushState } from "../../utils/url";
import { apiGetFaqList } from "../../utils/api";
import { Paging } from "../../models/Paging";
import { Faq } from "../../models/Faq";
import { setUpContactForm } from "../../components/contactForm";
import Header from "../../components/Header";
import { scrollTo } from "../../utils/utils";
import { LocalStorage } from "../../models/LocalStorage";
import Env from "../../environments";
import { setTranslateElements } from "../../utils/language";

const PER_PAGE = 10;
const DEBOUNCE_TIME = 500;

embedAllTrack();

initEvent();
initData();

function initEvent() {
  new Header({ parent: ".section.section-header", onEvent: { onLanguage: () => getData() }, hideShipping: false, hideCurrency: false });

  setUpType();
  loadMoreSetup();
  setUpSearch();
  setUpContactForm("faq");
  setUpFormFeedBack();

  $("body").on("click", ".section-data .faq-item .border-box .title-box", function () {
    $(this).parent().parent().toggleClass("active");
    historyPushState("#" + $(this).parent().parent().data("idx"));
    if ($(this).parent().parent().hasClass("active")) {
      scrollTo($(this).parent().parent(), 72, 1000);
    }
  })
}

function initData() {
  fillParam();
  getData(true);
  setUpNav();
}

function fillParam() {
  $(".section-data .type-box .item").removeClass("active");
  $(`.section-data .type-box .item[data-id='${getParamUrl("type") || "general"}']`).addClass("active");
  $(".search-form input").val(getParamUrl("term") || "");
}

function setUpNav() {
  window.onpopstate = () => {
    fillParam();
    getData();
  }
}

function search() {
  if (window.hsSearch && typeof window.hsSearch.abort === "function") {
    window.hsSearch.abort();
  }
  $(".search-form button").trigger("click");
}

const searchDebounce = debounce(DEBOUNCE_TIME)(search);

function setUpSearch() {
  $(".search-form").on("submit", function (e) {
    e.preventDefault();
    const url = changeQueryString("term", $(this).find("input").val() || undefined);
    historyPushState(url);
    getData();
  });

  window.term = $(".search-form input").val();
  $(".search-form input").on("keyup", function (e) {
    if (window.term !== $(this).val()) {
      if (e.keyCode !== 13) {
        searchDebounce();
      } else {
        searchDebounce.cancel();
      }
      window.term = $(this).val();
    }
  })
}

function startLoading() {
  $('.main-page').removeClass('no-result');
  $(".section-data").removeClass("load-more");
  $('.section-data .load-more').attr("loading", true)
  $('.section-data .container .border-box .scroll-box').html(genLoadingItem(PER_PAGE));
}

function stopLoading() {
  $('.section-data .load-more').attr("loading", false)
  $('.main-page').removeClass('loading');
}

function showNoResult() {
  $('.main-page').removeClass('loading');
  $('.main-page').addClass('no-result');
  $('.section-data .container .border-box .scroll-box').html('');
  $('.section-data').removeProp("paging");
}

function getData(isAutoScroll = false) {
  const term = getParamUrl("term") || undefined, country = LocalStorage.getShipping();
  const params = {
    p: 1,
    pp: PER_PAGE,
    fl: 0,
    dt: ["faq"],
    i: Env.DUTY_CAST_EXTENSION_FAQ_INDEX,
    soas: {
      "number_sort.id": "asc"
    }
  };
  if (term !== undefined) {
    params.t = {
      [LocalStorage.getLanguage()]: [term]
    }
  }
  if (country !== undefined) {
    params.f = {
      "country": ["all", String(country).toLowerCase()]
    }
  }
  startLoading();
  apiGetFaqList(params, function (result) {
    var data = Faq.fromApiArray(result.data);
    var paging = Paging.fromApiObject(result.paging);
    $('.section-data').prop("paging", paging);
    if (data.length) {
      let html = '';
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        html += item.genBox(i + 1);
      }
      $('.section-data .container .border-box .scroll-box').html(html);
    } else {
      showNoResult();
      stopLoading();
    }
    stopLoading();
    if (isAutoScroll) {
      autoScrollToItem(paging);
    }
  }, function (error) {
    showNoResult();
    stopLoading();
  })
}

function setUpType() {
  $("body").on("click", ".section-data .type-box .item", function () {
    if (!$(this).hasClass("active")) {
      $(".section-data .type-box .item").removeClass("active");
      $(this).addClass("active");
      const url = changeQueryString("type", $(this).attr("data-id") || undefined);
      historyPushState(url);
      getData();
    }
  });
}

function loadMoreSetup() {
  let lastScrollTop = $(window).scrollTop();
  $(window).scroll(function () {
    const top = $(this).scrollTop() + $(this).height() - ($(this).width() > 768 ? 200 : 100);
    let more = $('.section-data .load-more');
    if (top >= more.offset().top - 100 && $(window).scrollTop() > lastScrollTop && more.attr("loading") === "false" && !$('.main-page').hasClass("no-result") && !$('.section-data.load-more').hasClass("load-more")) {
      loadMore();
    }
    lastScrollTop = $(window).scrollTop();
  });
}

function loadMore(isAutoScroll = false) {
  const paging = $('.section-data').prop("paging");
  const term = getParamUrl("term") || undefined, country = LocalStorage.getShipping();

  if (paging && paging.currentPage < paging.totalPages) {
    const newPage = paging.currentPage + 1;
    startLoadMore(paging);
    const params = {
      p: newPage,
      pp: PER_PAGE,
      fl: 0,
      dt: ["faq"],
      i: Env.DUTY_CAST_EXTENSION_FAQ_INDEX,
      soas: {
        "number_sort.id": "asc"
      }
    };
    if (term !== undefined) {
      params.t = {
        [LocalStorage.getLanguage()]: [term]
      }
    }

    if (country !== undefined) {
      params.f = {
        "country": ["all", String(country).toLowerCase()]
      }
    }

    apiGetFaqList(params, function (result) {
      var data = Faq.fromApiArray(result.data);
      var paging = Paging.fromApiObject(result.paging);
      $('.section-data').prop("paging", paging);
      let html = '';
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        html += item.genBox(i + 1 + (paging.currentPage - 1) * paging.perPage);
      }
      stopLoadMore();
      $('.section-data .container .border-box .scroll-box').append($(html));
      if (isAutoScroll) {
        autoScrollToItem(paging);
      }
    }, function (error) {
      showNoResult();
      stopLoadMore();
    })
  }
}

function startLoadMore(paging) {
  const left = paging.totalCount - paging.currentPage * PER_PAGE;
  $(".section-data").addClass("load-more");
  $('.section-data .container .border-box .scroll-box').append($(genLoadingItem(PER_PAGE < left ? PER_PAGE : left)));
}

function stopLoadMore() {
  $('.section-data .container .border-box .scroll-box .item.loading').remove();
  $(".section-data").removeClass("load-more");
}

function genLoadingItem(num = 3) {
  let result = "";
  for (let i = 0; i < num; i++) {
    result += `
      <div class="faq-item item loading">
        <div class="border-box">
          <div class="title-box">
            <div class="arrow"></div>
            <div class="title"></div>
          </div>
          <div class="content fr-view"></div>
        </div>
      </div>
    `;
  }
  return result;
}

function autoScrollToItem(paging) {
  let hash = window.location.hash ? window.location.hash.replace("#", "") : "";
  if (hash && Number.isInteger(hash * 1)) {
    let itemFaq = $(`.section-data .container .border-box .scroll-box .faq-item[data-idx="${hash}"]`)
    if (itemFaq.length > 0) {
      itemFaq.addClass("active");
      scrollTo(itemFaq, 72, 1000);
    } else {
      if (paging.totalCount >= hash) {
        loadMore(true);
      }
    }
  }
}

function setUpFormFeedBack() {
  setTranslateElements([
    { element: $(".contact-form .section-contact-extension h2"), i18nKey: "faqs_stillHaveQuestion", isHtml: true },
    { element: $(".contact-form .section-contact-extension .feedback .label"), i18nKey: "faqs_askUsAnything", isHtml: true },
    { element: $(".contact-form .section-contact-extension .feedback textarea"), i18nKey: "faqs_enterYourQuestion", isPlaceholder: true },
  ])
}